import Link from "next/link";

import { Container, FooterSocialLink } from "@/components";
import { footerLinks, footerSocialLinks } from "@/util";

export const Footer = () => (
  <footer className="bg-black/20 backdrop-blur-md pb-48 md:pb-0 border-t">
    <Container disableVerticalPadding>
      <table className="w-full table-fixed">
        <thead>
          <tr className="border-b hidden md:table-row">
            {footerSocialLinks.map((props) => (
              <FooterSocialLink key={props.id} {...props} />
            ))}
          </tr>
          <tr className="border-b md:hidden">
            {footerSocialLinks.slice(0, 2).map((props) => (
              <FooterSocialLink key={props.id} {...props} />
            ))}
          </tr>
          <tr className="border-b md:hidden">
            {footerSocialLinks.slice(2).map((props) => (
              <FooterSocialLink key={props.id} {...props} />
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td className="border-l border-r space-y-2 capitalize hidden md:table-cell pb-56">
              <div className="text-2xl  text-themeWhite">mehdi faraji</div>
              <div className="tracking-wider text-xs">fullstack developer</div>
              <div className="uppercase  tracking-wider text-gray-400 pt-2 text-xs">
                &#169; {new Date().getFullYear()} all rights reserved.
              </div>
            </td>
            <td className="border-l border-r hidden md:table-cell" />
            <td className="border-l border-r hidden md:table-cell" />
            <td className="border-l border-r hidden md:table-cell pt-14 pb-40">
              <div className="uppercase  tracking-wider text-gray-400 text-sm pb-4">
                links
              </div>
              <ul className="space-y-1">
                {footerLinks.map(({ title, id, url }) => (
                  <li key={id} className="uppercase  tracking-wider">
                    <Link href={url} target="_blank" rel="noreferrer">
                      {title}
                    </Link>
                  </li>
                ))}
              </ul>
            </td>
          </tr>
          <tr className="h-20 table-row md:hidden">
            <td className="border-l" />
            <td className="border-r border-l" />
          </tr>
        </tbody>
      </table>
      <div className="block md:hidden">
        <div className="space-y-2 capitalize relative z-10 -translate-y-20 pt-14">
          <div className="text-2xl text-themeWhite">mehdi faraji</div>
          <div className="text-sm">fullstack developer</div>
          <div className="uppercase tracking-wider text-gray-400 pt-2 text-xs">
            &#169; {new Date().getFullYear()} all rights reserved
          </div>
        </div>
        <div className="uppercase  tracking-wider text-gray-400 pb-4">
          links
        </div>
        <div className="grid grid-cols-2 text-sm">
          <ul className="space-y-3">
            {footerLinks.slice(0, 5).map(({ title, id, url }) => (
              <li key={id} className="uppercase  tracking-wider">
                <Link href={url} target="_blank" rel="noreferrer">
                  {title}
                </Link>
              </li>
            ))}
          </ul>
          <ul className="space-y-3">
            {footerLinks.slice(5).map(({ title, id, url }) => (
              <li key={id} className="uppercase  tracking-wider">
                <Link href={url} target="_blank" rel="noreferrer">
                  {title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </Container>
  </footer>
);
